export const DONT_CANCEL = 'I do not want to cancel'
export const SEE_REFUND_BTN = 'See Refund Amount'
export const CANCEL_NOW = 'Yes, cancel now'
export const PREV_STEP = 'Take me back to Step 1'
export const CANCELLATION_FETCH_MSG = 'Loading Cancellation Details...'
export const CANCELLATION_REFUND_MSG = 'Validating and computing refund.'
export const CANCELLATION_CANCEL_MSG = 'Submitting Cancel request.'
export const TRIP_CANCELLATION_TITLE = 'Trip Cancellation'
export const CHOOSE_REASON = 'Choose reason for cancellation'
export const SELECT_PASSENGER = 'Select passengers to see refund amount'
export const VALIDATION_ERROR_BOTH =
  'Please select a reason for cancellation and at least one traveller.'
export const VALIDATION_ERROR_PAX =
  'Please select at least one traveller for cancellation.'
export const VALIDATION_ERROR_REASON =
  'Please select a reason for cancellation.'
export const BACK_TO_TRIPS = '← Back to trips'
export const RATING_POOR = 'Not likely'
export const RATING_EXCELLENT = 'Very likely'
export const RATING_HEADER = 'Based on your recent cancellation experience, how likely are you to recommend Cleartrip to your friends and colleagues? '
export const CANCELLATION_HEADER = 'Your cancellation is confirmed.'
export const CANCELLATION_BODY = 'Your cancellation is confirmed. Once the refund is processed, it will be credited to your account in 3 to 12 working days, depending on your bank and original payment mode.'
export const ALTERNATE_REFUND_CANCELLATION_BODY = 'Your cancellation is confirmed. Once the refund is processed, it will be credited to you in 1 working day(s).'
export const ALTERNATE_REFUND_WALLET_BODY = 'Your cancellation has been confirmed and the refund amount has been processed to your Cleartrip Wallet Credit balance.'
export const OPEN_TICKET_CANCELLATION_BODY = 'Your request to convert into an open ticket/credit shell is confirmed. To rebook your open ticket or utilise credit shell, Kindly click on "contact us" and select the "Rebook open ticket or utilise credit shell" option.'
export const MEDICAL_REASON_CANCELLATION_BODY = 'Your cancellation is confirmed. Once you submit the required documents we will validate and process the refund within 24-48 hrs.'
export const MEDICAL_REASON_ALT_CANCELLATION_BODY = 'Your cancellation is confirmed. Once you submit the required documents we will validate and process the refund within 24-48 hrs.'
export const SUPERCOIN_MSG = 'Any SuperCoins yet to be earned from this booking have been cancelled.'
export const EZCANCEL_PRO_BOOKING_CNF = 'As this an EZCancel Pro booking, we have processed your full refund. Depending on your bank and original payment mode, the refund will be credited to your account in 3 to 12 working days.'
export const EZCANCEL_PRO_REFUND_BOOKING_CNF = 'As this an EZCancel Pro booking, we have processed your full refund. The refund will be credited to you in 1 working day(s).'
export const REFUND_DETAILS = 'Refund Details'
export const PASSENGER_DETAILS = 'Passenger Details'
export const TRAVEL_DETAILS = 'Travel Details'
export const YOU_PAID = 'You Paid'
export const REFUND_BREAKUP = 'Refund Breakup'
export const REVIEW_REFUND = 'Review Refund'
export const REVIEW_REFUND_HELPER_TEXT =
  'What you should know before cancelling these tickets?'
export const CTWALLET_REFUND_NOTE = `Refunds processed to Cleartrip Wallet balance can't be
  redeemed into any other Wallet/Bank/Credit card account.`
export const CONFIRMATION_NOTE = 'Do you want to proceed with the cancellation?'
export const CONFIRMATION_WARNING = `The refund amount is approximate and is calculated on the basis of
            the fare rules & restrictions and flight booking policy. The final
            amount refunded to your account may vary.`
export const WALLET_CONFIRMATION_WARNING = `Once the refund is processed, it will be credited to your account in 3 to 12 working days,
            depending on your bank. Any remaining amount due towards Cleartrip  Wallet will be 
            issued in the form of Gift Card.`
export const CANCELLATION_API_STATUS = {
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  EMPTY: 'EMPTY'
}
export const SUBMIT_FEEDBACK = 'Submit Feedback'
export const SUBMIT = 'Submit'
export const ALREADY_AMEND_QUESTION =
  'Did you already amend this Trip with the airline?'
export const UPLOAD_PROOF = 'Upload any proof received from the Airline'
export const CAN_BE_PDF =
  'File can be a PDF, word document or a downloaded email'
export const OPTIONAL = 'Optional'

export const CANCELLATION_ERROR_STATES = {
  NON_CANCELLABLE_BOOKING_STATUS: 'This trip cannot be cancelled online. For additional assistance, Please click on ‘Contact Us’ on trip details page and select the ‘Need more help’ option.',
  NO_ADULT_IN_ALL_SEGMENT:
    'After cancellation, at least one adult must accompany a child on each flight.',
  ADULT_INFANT_MISMATCH:
    'After cancellation, the number of adults should be equal to or more than the number of infants.',
  INTERNATIONAL_PARTIAL_CANCEL:
    'This trip cannot be cancelled partially online. For additional assistance, Please click on ‘Contact Us’ on trip details page and select the ‘Need more help’ option or cancel the entire trip.',
  JET_AIRWAYS_BOOKING:
    ' This trip cannot be cancelled online. For additional assistance, Please click on ‘Contact Us’ on trip details page and select the ‘Need more help’ option.',
  SPECIAL_RT_PARTIAL_CANCEL:
    'This trip was booked on a special discounted round trip fare offered by the airline. Hence, for partial cancellations, We shall confirm the refund amount only after verifying with the airline. For additional assistance, Please click on ‘Contact Us’ on trip details page and select the ‘Need more help’ option',
  INCORRECT_ABI_IDS: '',
  FREEDOM_FARE: 'This trip is not eligible for partial cancellation.',
  CORP_CANCEL:
    'Cancellations for corporate trips is not allowed from your personal Cleartrip account',
  AIRPORT_SHUTDOWN_PARTIAL_CANCEL:
    'Partial cancellation not allowed for airport shutdown.',
  OPEN_TXN_PRESENT:
    ' This trip cannot be cancelled online. For additional assistance, Please click on ‘Contact Us’ on trip details page and select the ‘Need more help’ option'
}

export const NOTICE_STATES = {
  EXPIRED:
    "Since you are cancelling your booking post departure, the airline will consider this cancellation to be a 'no-show' unless you have already cancelled directly with the airline. We will check with the airline and process a refund accordingly.",
  FREEDOM_FARE_BOOKING:
    'Freedom fare benefits are valid only on full cancellations, per passenger. Partial trip cancellations (on a round-trip booking) will not be considered.',
  SPECIAL_RT_BOOKING:
    'This trip was booked as special discounted round trip fare offered by airline. We need to check with airline before we can confirm your refund amount.',
  NO_SHOW:
    'Since you are cancelling your booking close to the departure time, the airline may consider this cancellation to be a \'no- show\' (similar to you missing the flight without cancelling). We will check with the airline and process a refund accordingly.',
  TF_CANCEL:
    'Airline will not process your refund. They will provide you with a credit which you can use for your future bookings with the same airline. Kindly contact the airline for more details of the same.',
  EZCANCEL_BOOKING:
    'As this is an EzCancel booking, the "Airline charge" upto ₹3500.00 will be refunded to you seperately after cancellation.',
  EZCANCEL_PRO_BOOKING:
    'As this is an EzCancel booking, you will get a full refund on cancellation.',
  EZCANCEL_BOOKING_CNF:
    'As this is an EzCancel booking, the "Airline charge" upto ₹3500.00 will be refunded to you seperately. Our partner will reach out to you for bank details to process the refund.'
}

export const REFUND_STATES = {
  CUSTOMER_DIRECTLY_CANCELLED_FROM_AIRLINE:
    'Refund will be processed after consulting the airline',
  CUSTOMER_MISSED_FLIGHT:
    'Refund will be processed after consulting the airline',
  INTERNATIONAL_REFUND:
    'Cancellation rules for international bookings are very complex and can not be computed automatically. You may want to take a look at the fare rules to understand how much refund will be credited back to you.',
  RESCHEDULED_BY_AIRLINE:
    'Refund will be processed after consulting the airline',
  CANCELLED_BY_AIRLINE: 'Refund will be processed after consulting the airline',
  MEDICAL_REASON: 'Note: Post cancellation, the refund amount post deduction of applicable charges will be credited. Upon submitting a valid medical certificate by an authorized medical practitioner the documents, the Medi-Cancel benefit amount will also be credited to the original source of payment. For FAQs and T&C, ',
  AIRPORT_SHUTDOWN: 'Refund will be processed after consulting the airline',
  REFUND_NOT_CALCULATED: 'Refund will be processed after verifying the amount with the airline.'
}

export const REFUND_STATES_URL_TEXT = {
  MEDICAL_REASON: 'click here'
}

export const PWA_LABEL_STATUS = 'Status:'
export const PWA_LABEL_PAID = 'Total Paid:'
export const PWA_LABEL_PNR = 'PNR:'

export const CANCEL_CHARGE_NOTE = 'Note: Above charges are applicable if you cancel before the mentioned date. Other charges include payment gateway charges'
export const AMEND_CHARGE_NOTE = 'Note: Above charges are applicable if you amend before the mentioned date. Other charges include payment gateway charges'

export const FARE_RULE_ERROR = 'Unable to fetch the airline cancellation charges at the moment.'

export const NEGATIVE_REFUND_NOTE = '*Calculated refund value is negative, hence Total Refund is NIL.'

export const EZCANCEL_BANNER_NOTE_FAQ = 'For EzCancel bookings, Cleartrip will refund airline cancellation fees upto 3500 on cancellation.'

export const CHOOSE_REFUND = 'Choose where you want your refund'

export const MEDICAL_REASON_NOTE = 'Please select this option only if the Passenger or an immediate family member or travelling companion is sick, injured or deceased. To know more about refund process '
